































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Skill from '@/domain/drd-2.0/entity/skill.entity';

export type ResponsibilityText = {
  portuguese: string;
  english: string;
  espanish: string;
};

@Component({
  components: {
    LabelSlot,
  },
})
export default class SkillFormComponent extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
  }) initialValue!: Skill;

  @Prop({
    type: String,
    default: '',
  }) submitButtonText!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) showCancel!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) disableSubmit!: boolean;

  @Prop({
    type: String,
    default: '',
  }) submitTooltipMessage!: string;

  tab = null;

  text: ResponsibilityText = {
    portuguese: this.initialValue.whatPTBR,
    english: this.initialValue.whatEN,
    espanish: this.initialValue.whatES,
  };

  submit() {
    if (!this.text.portuguese) {
      return;
    }
    this.$emit('submit', this.text);
    this.clear();
  }

  clear() {
    this.text = {
      portuguese: '',
      english: '',
      espanish: '',
    };
  }

  cancel() {
    this.$emit('cancel');
  }
}
